<div class="payment-status-screen">
  <div class="img-container">
    <img src="assets/images/taly-dark-icon.svg" alt="taly" />
  </div>
  <div class="img-container-loader">
    @if (message === 'PROCESSING') {
      <img [src]="'assets/images/loader-icon.gif'" alt="loader-icon" />
    } @else {
      <img
        [alt]="isSuccess ? 'success' : 'reject-logo'"
        [src]="isSuccess ? 'assets/images/payment-success.svg' : 'assets/images/reject-logo.svg'"
      />
    }
  </div>
  <div class="section-title">
    <h4>{{ message === 'PROCESSING' ? ('PROCESSING' | translate) : message }}</h4>
  </div>
</div>
